// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"89370697","162":"7360e0f5","254":"5fc58c98","318":"8022338a","505":"cdd61af5","541":"cb1e9cca"}[chunkId] + ".css";
};